import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-wmv-file-icon',
  templateUrl: './doc-format-wmv-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatWmvFileIconComponent {}
